import React from "react";
import Divider from '@mui/material/Divider';
import Typography from "@mui/material/Typography";
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid2';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    ...theme.applyStyles('dark', {
        backgroundColor: '#1A2027',
    }),
}));

const PageTitle = ({ title, role }) => {
    return (<div>
        <Box sx={{ flexGrow: 1, py: '20px' }}>
            <Grid container spacing={3} alignItems="center">
                <Grid size="auto">
                    <Typography variant="h4" component="div">
                        {title}
                    </Typography>
                </Grid>
                <Grid size="grow"></Grid>
                {role && (
                    <Grid size="auto">
                        <Item>
                            Default Role: {role}
                        </Item>
                    </Grid>
                )}
            </Grid>
        </Box>
        <Divider />
    </div>
    );
};

export default PageTitle;
